import React from 'react';
import styles from './HealthStatus.module.scss';

const HealthStatus = ({
  className = '',
  color = '',
  name = '',
  size = 'normal',
  onClick,
}) => {
  const colorClass = styles[`StatusColor--${color}`]
    ? styles[`StatusColor--${color}`]
    : '';

  const sizeClass = styles[`StatusSize--${size}`]
    ? styles[`StatusSize--${size}`]
    : '';

  if (onClick) {
    return (
      <button
        className={`${styles.Status} ${colorClass} ${sizeClass} ${className}`}
        data-clickable
        onClick={onClick}
      >
        {name}
      </button>
    );
  }

  return (
    <div className={`${styles.Status} ${colorClass} ${sizeClass} ${className}`}>
      {name}
    </div>
  );
};

export default HealthStatus;
